import { Component, Inject } from '@angular/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { TuiDialog } from '@taiga-ui/cdk';

@Component({
  selector: 'df-funnel-settings-close-alert',
  templateUrl: './funnel-settings-close-alert.component.html',
  styleUrls: ['./funnel-settings-close-alert.component.scss'],
})
export class FunnelSettingsCloseAlertComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    readonly context: TuiDialog<FunnelSettingsCloseAlertComponent, boolean>,
  ) {}

  confirmExit(): void {
    this.context.completeWith(true);
  }

  cancel(): void {
    this.context.completeWith(false);
  }
}
